import { QuoteItemStockStatus } from '@common/utils'
import { MolsonBox, MolsonTypography } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
import { useTranslation } from 'react-i18next'
import { CustomChip } from '../custom-chip/CustomChip'

export const StockItemChip = ({
  stockStatus
}: {
  stockStatus?: string | QuoteItemStockStatus | null
}) => {
  const theme = molsonUseTheme()
  const { t } = useTranslation('', { keyPrefix: 'common' })

  const chipText = () => {
    if (stockStatus === QuoteItemStockStatus.SOLD) {
      return t('sold')
    }

    if (stockStatus === QuoteItemStockStatus.SOLD_PENDING_DELIVERY) {
      return t('onOrderPendingDelivery')
    }

    return ''
  }

  const chipStyling = () => {
    if (stockStatus === QuoteItemStockStatus.SOLD) {
      return {
        backgroundColor: `${theme.palette.primary.errorBannerBg}`,
        color: `${theme.palette.primary.error}`
      }
    }

    if (stockStatus === QuoteItemStockStatus.SOLD_PENDING_DELIVERY) {
      return {
        backgroundColor: `${theme.palette.secondary.lightPeach}`,
        color: `${theme.palette.primary.warningContent}`
      }
    }

    return null
  }

  const oldItemStatus = () => {
    return stockStatus !== QuoteItemStockStatus.SOLD &&
      stockStatus !== QuoteItemStockStatus.SOLD_PENDING_DELIVERY
      ? stockStatus
      : null
  }

  return (
    <MolsonBox alignItems="center" display="flex" gap="2px">
      <CustomChip
        customSx={{
          ...chipStyling(),
          borderRadius: '5px',
          height: 'fit-content',
          display: 'flex',
          alignItems: 'center'
        }}
        text={chipText()}
      />
      <MolsonTypography
        color={theme.palette.secondary[500]}
        sx={{
          textDecoration: 'line-through'
        }}
        variant="body2"
      >
        {oldItemStatus()}
      </MolsonTypography>
    </MolsonBox>
  )
}
